/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Webhook_Address_CopiedInputs */



/**
* | output |
* | --- |
* | "Webhook address copied." |
*
* @param {Spaces_Webhook_Address_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_webhook_address_copied = /** @type {((inputs?: Spaces_Webhook_Address_CopiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Webhook_Address_CopiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Webhook-Adresse kopiert.")
	return /** @type {LocalizedString} */ ("Webhook address copied.")
});